import { ClientOnly } from '@tanstack/react-router'
import type { useFloraCanvasModel } from '@/components/home/components/flora-canvas/flora-canvas.model'

type FloraCanvasViewProps = ReturnType<typeof useFloraCanvasModel>

export function FloraCanvasView({
  canvasRef,
  isSceneReady,
}: FloraCanvasViewProps) {
  return (
    <ClientOnly fallback={<FloraCanvasPoster sceneReady={false} />}>
      <div aria-hidden="true">
        <canvas ref={canvasRef} className="fz-flora-canvas__canvas" />
      </div>
      <FloraCanvasPoster sceneReady={isSceneReady} />
    </ClientOnly>
  )
}

function FloraCanvasPoster({ sceneReady }: { sceneReady: boolean }) {
  const modifier = sceneReady ? ' fz-flora-canvas__poster--hidden' : ''
  return (
    <div className={`fz-flora-canvas__poster${modifier}`} aria-hidden="true">
      <div className="fz-flora-canvas__loader">
        <svg
          className="fz-flora-canvas__loader-petal"
          viewBox="0 0 24 32"
          aria-hidden="true"
          focusable="false"
        >
          <path
            fill="none"
            stroke="currentColor"
            strokeWidth="1.3"
            d="M12 2 C 4 10, 2 22, 12 30 C 22 22, 20 10, 12 2 Z"
          />
          <path
            fill="none"
            stroke="currentColor"
            strokeWidth="1"
            d="M12 8 L12 26"
          />
        </svg>
        <span className="fz-flora-canvas__loader-label">
          preparando o jardim…
        </span>
      </div>
    </div>
  )
}
